import { render, staticRenderFns } from "./line-chart.vue?vue&type=template&id=2538a9f6&scoped=true"
import script from "./line-chart.vue?vue&type=script&lang=js"
export * from "./line-chart.vue?vue&type=script&lang=js"
import style0 from "./line-chart.vue?vue&type=style&index=0&id=2538a9f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2538a9f6",
  null
  
)

export default component.exports